import { Route } from "react-router-dom";

import { routes } from "constants/routes";
import TruckManage from "features/main/Trucks";
import TruckDetail from "features/main/Trucks/Detail";
import MyPostedTrucks from "features/main/Trucks/List";
import TruckMatchesList from "features/main/Trucks/MatchesList";
import TruckPost from "features/main/Trucks/Post";
import TruckSearch from "features/main/Trucks/Search";
import useDeviceType from "hooks/useDeviceType";
import { useUserFeature } from "hooks/useUserFeature";

export default function TrucksRoutes() {
  const { isDesktop } = useDeviceType();
  const { isCarrier, isShipper } = useUserFeature();

  return (
    <Route path={routes.TRUCKS}>
      {!isDesktop && <Route index element={<TruckManage />} />}

      {!isCarrier && (
        <Route path="search">
          <Route path="" element={<TruckSearch />} />
          <Route path=":truckId" element={<TruckDetail />} />
        </Route>
      )}

      {!isShipper && (
        <Route path="post">
          <Route path="" element={<TruckPost />} />
          <Route path=":postedId" element={<TruckPost />} />
        </Route>
      )}

      {!isShipper && (
        <Route path="my-posted">
          <Route path="" element={<MyPostedTrucks />} />
          <Route path=":truckId" element={<TruckDetail />} />
          <Route path=":truckId/matches" element={<TruckMatchesList />} />
        </Route>
      )}
    </Route>
  );
}
